import InvitationsSend from "./InvitationsSend/InvitationsSend";
import Invitations from "./Invitations/Invitations";
import My from "./My/My";

export default [
	{
		key: "userpanelFriendsMy",
		component: My,
		path: "/userpanel/friends/my/:page?",
		link: "/userpanel/friends/my",
	},
	{
		key: "userpanelFriendsInvitations",
		component: Invitations,
		path: "/userpanel/friends/invitations/:page?",
		link: "/userpanel/friends/invitations",
	},
	{
		key: "userpanelFriendsInvitationssend",
		component: InvitationsSend,
		path: "/userpanel/friends/invitationssend/:page?",
		link: "/userpanel/friends/invitationssend",
	},
];
